import { Card, Divider, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { DeleteAccountForm } from "../components/DeleteAccountForm";

const { Title, Paragraph, Text } = Typography;

/**
 * `/delete-account` — hisobni o'chirish so'rovi sahifasi.
 *
 * ⚠️ **Google Play «Data deletion» talabi.** Do'kon ilova sahifasidan
 * ochiladigan, HISOBSIZ ko'riladigan URL talab qiladi. Shu sababli
 * marshrut `rootRoute` ostida to'g'ridan-to'g'ri turadi:
 *
 *   - `authLayoutRoute` ostida BO'LMAYDI — `AuthLayout` kirgan
 *     foydalanuvchini `/dashboard` ga otib yuboradi;
 *   - `mainLayoutRoute` ostida ham BO'LMAYDI — u `ProtectedRoute` bilan
 *     o'ralgan;
 *   - `RootRoute` ning `PUBLIC_PATHS` ro'yxatiga qo'shilgan, aks holda
 *     kirmagan tashrifchi darhol `/login` ga yo'naltirilardi.
 *
 * ⚠️ **Sahifa hech narsani o'chirmaydi.** Forma so'rovni `audit_log` ga
 * qayd etadi, qaror esa mas'ul xodimda qoladi — matn ham aynan shuni
 * aytadi va «hisobingiz o'chirildi» DEMAYDI.
 */
export function DeleteAccountPage() {
	const { t } = useTranslation("accountDeletion");

	return (
		<div className="min-h-screen bg-[#f6f6f4] flex justify-center p-4 sm:p-6">
			<Card className="w-full max-w-2xl h-fit shadow-lg">
				<Title level={2} className="!mb-1">
					{t("page.title")}
				</Title>
				<Text type="secondary">{t("page.subtitle")}</Text>

				<Divider />

				<Title level={4}>{t("page.howItWorksTitle")}</Title>
				<Paragraph>{t("page.howItWorksBody1")}</Paragraph>
				<Paragraph>{t("page.howItWorksBody2")}</Paragraph>

				<Title level={4}>{t("page.whatIsDeletedTitle")}</Title>
				<Paragraph>{t("page.whatIsDeletedBody")}</Paragraph>

				<Title level={4}>{t("page.whatIsKeptTitle")}</Title>
				<Paragraph>{t("page.whatIsKeptBody")}</Paragraph>

				<Divider />

				<Title level={4} className="!mb-4">
					{t("page.sendRequestTitle")}
				</Title>
				<DeleteAccountForm />

				{/*
				 * Bog'lanish ma'lumoti (HR bo'limi elektron pochtasi / telefoni) shu
				 * yerga qo'yiladi. ⚠️ ATAYLAB BO'SH: taxminiy manzil yozilsa,
				 * so'rov yuborgan xodim javobsiz qolardi. Play tekshiruvi bu
				 * blokni odatda talab qiladi.
				 */}
			</Card>
		</div>
	);
}
